/*
 * @Author: cc
 * @Date: 2020-04-02 10:00:07
 * @LastEditTime: 2020-08-28 14:28:08
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWo.js
 * @Description: iwo 总模块
 */
'use strict';
angular.module('editingCenterIWoModule', [
    'iWoLeftModule',
    'editingCenterIWoRouterModule',
    'iWoMyManuscriptModule',
    'iWoResourceModule',
    'myManuscriptService',
    'fusionPendingModule',
    'fusionSignModule',
    'iWoPrivilegeDraftModule',
    'iWoDraftBoxModule',
    'iWoObjTimeModule',
    'iWoBtnServiceModule',
    'iWoPreveiwRouterModule',
    'iWoServiceModule',
    'editFusionEditorModule',
    'iwoNoticeModule',
    'withdrawalMgtModule' // 撤稿指令管理
]).controller('editingCenterIWoCtrl', [function() {

}]).value('iWoConst', {
    listenStroageKey: 'iWo', // 监听缓存的名称
    // IWO渠道常量（包括请求参数、完整渠道变量等常量）
    personalShare: { // 个人稿库共享
        serviceid: 'mlf_fusionmyrelease',
        methodname: 'personalMyShare',
    },
    receiveShare: { // 已收稿库共享
        serviceid: 'mlf_fusionmyrelease',
        methodname: 'receivedMyShare',
    },
    deptShare: { // 部门稿库共享
        serviceid: 'mlf_departoperdoc',
        methodname: 'shareDepartmentalDocs',
    }
});
